import React, { useState, useEffect } from 'react';
import inspectionStorage from '../services/inspectionStorage';

const ERP_TYPES = [
  { value: 'J', label: 'J - Structures d\'accueil personnes âgées / handicapées' },
  { value: 'L', label: 'L - Salles d\'auditions, conférences, spectacles' },
  { value: 'M', label: 'M - Magasins, centres commerciaux' },
  { value: 'N', label: 'N - Restaurants et débits de boisson' },
  { value: 'O', label: 'O - Hôtels et pensions de famille' },
  { value: 'P', label: 'P - Salles de danse et salles de jeux' },
  { value: 'R', label: 'R - Établissements d\'enseignement' },
  { value: 'S', label: 'S - Bibliothèques, centres de documentation' },
  { value: 'T', label: 'T - Salles d\'expositions' },
  { value: 'U', label: 'U - Établissements de soins' },
  { value: 'V', label: 'V - Établissements de culte' },
  { value: 'W', label: 'W - Administrations, banques, bureaux' },
  { value: 'X', label: 'X - Établissements sportifs couverts' },
  { value: 'Y', label: 'Y - Musées' },
  { value: 'PA', label: 'PA - Établissements de plein air' },
  { value: 'CTS', label: 'CTS - Chapiteaux, tentes et structures' },
  { value: 'SG', label: 'SG - Structures gonflables' },
  { value: 'OA', label: 'OA - Hôtels-restaurants d\'altitude' },
  { value: 'REF', label: 'REF - Refuges de montagne' },
  { value: 'PS', label: 'PS - Parcs de stationnement couverts' },
  { value: 'GA', label: 'GA - Gares' },
  { value: 'EF', label: 'EF - Établissements flottants' },
  { value: 'EP', label: 'EP - Espaces de présentation du patrimoine' },
];

const CATEGORIES = [
  { value: '1', label: '1ère catégorie (1501 personnes et +)' },
  { value: '2', label: '2ème catégorie (701 à 1500 personnes)' },
  { value: '3', label: '3ème catégorie (301 à 700 personnes)' },
  { value: '4', label: '4ème catégorie (jusqu\'à 300 personnes)' },
  { value: '5', label: '5ème catégorie (seuils spécifiques par type)' },
];

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
    paddingBottom: '100px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  headerTitle: { fontSize: '16px', fontWeight: '700', margin: 0 },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  saveBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '18px',
    cursor: 'pointer',
  },
  badge: {
    margin: '16px 20px',
    padding: '12px 16px',
    background: 'linear-gradient(135deg, #ede9fe, #ddd6fe)',
    border: '2px solid #8b5cf6',
    borderRadius: '12px',
    color: '#5b21b6',
    fontWeight: '600',
    textAlign: 'center',
    fontSize: '13px',
  },
  content: { padding: '0 20px' },
  card: {
    background: 'white',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  sectionTitle: {
    fontSize: '15px',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '600',
    color: '#475569',
    marginBottom: '6px',
  },
  input: {
    width: '100%',
    padding: '12px',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    fontSize: '15px',
    boxSizing: 'border-box',
    background: '#fff',
  },
  select: {
    width: '100%',
    padding: '12px',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    fontSize: '15px',
    boxSizing: 'border-box',
    background: '#fff',
  },
  textarea: {
    width: '100%',
    padding: '12px',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    fontSize: '15px',
    boxSizing: 'border-box',
    minHeight: '100px',
    fontFamily: 'inherit',
  },
  fieldGroup: { marginBottom: '14px' },
  etabCard: {
    background: '#f8fafc',
    borderRadius: '12px',
    padding: '14px',
    marginBottom: '12px',
    border: '1px solid #e2e8f0',
  },
  etabHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  deleteBtn: {
    background: '#fef2f2',
    border: '1px solid #fecaca',
    color: '#dc2626',
    padding: '6px 10px',
    borderRadius: '8px',
    fontSize: '12px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  addButton: {
    width: '100%',
    padding: '14px',
    background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    fontWeight: '700',
    fontSize: '14px',
    cursor: 'pointer',
    marginTop: '8px',
  },
  radioRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    padding: '12px',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    marginBottom: '10px',
    cursor: 'pointer',
  },
  radioRowActive: {
    borderColor: '#8b5cf6',
    background: '#f5f3ff',
  },
  saveSection: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 20px',
    background: 'white',
    borderTop: '1px solid #e2e8f0',
    boxShadow: '0 -4px 12px rgba(0,0,0,0.06)',
  },
  saveButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    fontWeight: '700',
    fontSize: '16px',
    cursor: 'pointer',
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
  },
  emptyState: {
    textAlign: 'center',
    padding: '24px 12px',
    color: '#64748b',
    fontSize: '14px',
  },
};

const emptyEtab = () => ({
  batiment_local: '',
  effectif_public: '',
  effectif_personnel: '',
  effectif_total: '',
});

function Etape18CaracteristiquesERPMobile({ mission, onBack, onSave }) {
  const [data, setData] = useState({
    type_erp: '',
    categorie: '',
    types_additionnels: [],
    etablissements: [],
    description_sommaire: '',
    referentiel_applique: '',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const saved = await inspectionStorage.getStep(mission.id, 'etape_18_caracteristiques_erp');
        if (saved && typeof saved === 'object') {
          setData((prev) => ({ ...prev, ...saved }));
        }
      } catch (e) {
        console.error('Erreur chargement étape 18:', e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [mission.id]);

  const update = (field, value) => {
    setData((prev) => ({ ...prev, [field]: value }));
  };

  const addEtablissement = () => {
    setData((prev) => ({
      ...prev,
      etablissements: [...(prev.etablissements || []), emptyEtab()],
    }));
  };

  const updateEtablissement = (index, field, value) => {
    setData((prev) => {
      const list = [...(prev.etablissements || [])];
      list[index] = { ...list[index], [field]: value };
      return { ...prev, etablissements: list };
    });
  };

  const removeEtablissement = (index) => {
    setData((prev) => ({
      ...prev,
      etablissements: (prev.etablissements || []).filter((_, i) => i !== index),
    }));
  };

  const addTypeAdditionnel = () => {
    setData((prev) => ({
      ...prev,
      types_additionnels: [...(prev.types_additionnels || []), { type: '', categorie: '' }],
    }));
  };

  const updateTypeAdditionnel = (index, field, value) => {
    setData((prev) => {
      const list = [...(prev.types_additionnels || [])];
      list[index] = { ...list[index], [field]: value };
      return { ...prev, types_additionnels: list };
    });
  };

  const removeTypeAdditionnel = (index) => {
    setData((prev) => ({
      ...prev,
      types_additionnels: (prev.types_additionnels || []).filter((_, i) => i !== index),
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await inspectionStorage.saveStep(mission.id, 'etape_18_caracteristiques_erp', data);
      if (onSave) onSave(data);
      onBack();
    } catch (error) {
      console.error('Erreur sauvegarde étape 18:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={styles.loading}>
        <div
          style={{
            width: '40px',
            height: '40px',
            border: '4px solid #e2e8f0',
            borderTopColor: '#8b5cf6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }}
        />
        <p style={{ marginTop: '16px', color: '#64748b', fontWeight: '500' }}>Chargement...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>
          ← Retour
        </button>
        <h1 style={styles.headerTitle}>Caractéristiques ERP</h1>
        <button style={styles.saveBtn} onClick={handleSave} disabled={saving}>
          {saving ? '⏳' : '💾'}
        </button>
      </div>

      <div style={styles.badge}>
        🏛️ Rapport RVRAT - ERP 1er groupe
        <br />
        <span style={{ fontSize: '12px', fontWeight: '400' }}>Classement et effectifs de l&apos;établissement</span>
      </div>

      <div style={styles.content}>
        <div style={styles.card}>
          <div style={styles.sectionTitle}>Type et catégorie</div>
          <div style={styles.fieldGroup}>
            <label style={styles.label}>Type ERP principal *</label>
            <select
              style={styles.select}
              value={data.type_erp || ''}
              onChange={(e) => update('type_erp', e.target.value)}
            >
              <option value="">-- Sélectionner --</option>
              {ERP_TYPES.map((t) => (
                <option key={t.value} value={t.value}>
                  {t.label}
                </option>
              ))}
            </select>
          </div>
          <div style={{ ...styles.fieldGroup, marginBottom: 0 }}>
            <label style={styles.label}>Catégorie *</label>
            <select
              style={styles.select}
              value={data.categorie || ''}
              onChange={(e) => update('categorie', e.target.value)}
            >
              <option value="">-- Sélectionner --</option>
              {CATEGORIES.map((c) => (
                <option key={c.value} value={c.value}>
                  {c.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div style={styles.card}>
          <div style={styles.sectionTitle}>Types additionnels</div>
          {(data.types_additionnels || []).length === 0 ? (
            <div style={styles.emptyState}>Aucun type additionnel</div>
          ) : (
            (data.types_additionnels || []).map((ta, index) => (
              <div key={index} style={styles.etabCard}>
                <div style={styles.etabHeader}>
                  <strong style={{ fontSize: '13px' }}>Type #{index + 1}</strong>
                  <button style={styles.deleteBtn} onClick={() => removeTypeAdditionnel(index)}>
                    🗑️
                  </button>
                </div>
                <div style={styles.fieldGroup}>
                  <label style={styles.label}>Type ERP</label>
                  <select
                    style={styles.select}
                    value={ta.type || ''}
                    onChange={(e) => updateTypeAdditionnel(index, 'type', e.target.value)}
                  >
                    <option value="">--</option>
                    {ERP_TYPES.map((t) => (
                      <option key={t.value} value={t.value}>
                        {t.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{ ...styles.fieldGroup, marginBottom: 0 }}>
                  <label style={styles.label}>Catégorie</label>
                  <select
                    style={styles.select}
                    value={ta.categorie || ''}
                    onChange={(e) => updateTypeAdditionnel(index, 'categorie', e.target.value)}
                  >
                    <option value="">--</option>
                    {CATEGORIES.map((c) => (
                      <option key={c.value} value={c.value}>
                        {c.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            ))
          )}
          <button style={styles.addButton} onClick={addTypeAdditionnel}>
            ➕ Ajouter un type
          </button>
        </div>

        <div style={styles.card}>
          <div style={styles.sectionTitle}>Référentiel appliqué *</div>
          <div
            style={{
              ...styles.radioRow,
              ...(data.referentiel_applique === 'CCH_R123.43_Arrete_25_06_1980' ? styles.radioRowActive : {}),
            }}
            onClick={() => update('referentiel_applique', 'CCH_R123.43_Arrete_25_06_1980')}
          >
            <input
              type="radio"
              checked={data.referentiel_applique === 'CCH_R123.43_Arrete_25_06_1980'}
              onChange={() => update('referentiel_applique', 'CCH_R123.43_Arrete_25_06_1980')}
            />
            <div>
              <div style={{ fontWeight: 700, fontSize: '13px' }}>
                Code de la construction (R123.43) et arrêté du 25/06/1980
              </div>
              <div style={{ fontSize: '12px', color: '#64748b', marginTop: 4 }}>
                Référentiel réglementaire standard pour les ERP
              </div>
            </div>
          </div>
          <div
            style={{
              ...styles.radioRow,
              marginBottom: 0,
              ...(data.referentiel_applique === 'Prescription_Permis_Construire' ? styles.radioRowActive : {}),
            }}
            onClick={() => update('referentiel_applique', 'Prescription_Permis_Construire')}
          >
            <input
              type="radio"
              checked={data.referentiel_applique === 'Prescription_Permis_Construire'}
              onChange={() => update('referentiel_applique', 'Prescription_Permis_Construire')}
            />
            <div>
              <div style={{ fontWeight: 700, fontSize: '13px' }}>
                Prescription du permis de construire / autorisation de travaux
              </div>
              <div style={{ fontSize: '12px', color: '#64748b', marginTop: 4 }}>
                Prescriptions spécifiques de l&apos;autorisation administrative
              </div>
            </div>
          </div>
        </div>

        <div style={styles.card}>
          <div style={styles.sectionTitle}>Classement de l&apos;établissement</div>
          {(data.etablissements || []).length === 0 ? (
            <div style={styles.emptyState}>Aucun bâtiment ajouté</div>
          ) : (
            (data.etablissements || []).map((etab, index) => (
              <div key={index} style={styles.etabCard}>
                <div style={styles.etabHeader}>
                  <strong style={{ fontSize: '13px' }}>Bâtiment #{index + 1}</strong>
                  <button style={styles.deleteBtn} onClick={() => removeEtablissement(index)}>
                    🗑️
                  </button>
                </div>
                <div style={styles.fieldGroup}>
                  <label style={styles.label}>Bâtiment / Local</label>
                  <input
                    style={styles.input}
                    value={etab.batiment_local || ''}
                    onChange={(e) => updateEtablissement(index, 'batiment_local', e.target.value)}
                    placeholder="Ex: Général Bricolage Abymes"
                  />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px' }}>
                  <div style={{ ...styles.fieldGroup, marginBottom: 0 }}>
                    <label style={styles.label}>Effectif public</label>
                    <input
                      type="number"
                      style={styles.input}
                      value={etab.effectif_public || ''}
                      onChange={(e) => updateEtablissement(index, 'effectif_public', e.target.value)}
                      placeholder="1140"
                    />
                  </div>
                  <div style={{ ...styles.fieldGroup, marginBottom: 0 }}>
                    <label style={styles.label}>Effectif personnel</label>
                    <input
                      type="number"
                      style={styles.input}
                      value={etab.effectif_personnel || ''}
                      onChange={(e) => updateEtablissement(index, 'effectif_personnel', e.target.value)}
                      placeholder="19"
                    />
                  </div>
                  <div style={{ ...styles.fieldGroup, marginBottom: 0 }}>
                    <label style={styles.label}>Effectif total</label>
                    <input
                      type="number"
                      style={styles.input}
                      value={etab.effectif_total || ''}
                      onChange={(e) => updateEtablissement(index, 'effectif_total', e.target.value)}
                      placeholder="1159"
                    />
                  </div>
                </div>
              </div>
            ))
          )}
          <button style={styles.addButton} onClick={addEtablissement}>
            ➕ Ajouter un bâtiment
          </button>
        </div>

        <div style={styles.card}>
          <div style={styles.sectionTitle}>Description sommaire des installations</div>
          <textarea
            style={styles.textarea}
            value={data.description_sommaire || ''}
            onChange={(e) => update('description_sommaire', e.target.value)}
            placeholder="Description des installations (normal, remplacement, sécurité)..."
          />
        </div>
      </div>

      <div style={styles.saveSection}>
        <button
          style={{ ...styles.saveButton, ...(saving ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }}
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>
    </div>
  );
}

export default Etape18CaracteristiquesERPMobile;
